import { CreditOperatorFormData } from "@/formTypes/CreditOperatorFormDataType";
import { ApiSchema } from "@/api/ApiClient";
import { GenericModelApi } from "./GenericModelApi";

export type CreditOperatorDataType = Partial<ApiSchema["CreditOperator"]["type"] & CreditOperatorFormData>;
export const CreditOperatorApi = new GenericModelApi<"CreditOperator", CreditOperatorDataType>("CreditOperator", "nombre");

// In case is required to override a method or extende please take use the next  lines  
//
// class CustomCreditOperatorApi extends GenericModelApi<"CreditOperator", CreditOperatorDataType> {
//     async fetchByCurrency(currencyId: number) {
//       return this.fetchAll({ currency_id: { eq: currencyId } });
//     }
//   }